import React, { Component } from 'react';
import firebase from 'firebase/app';
import axios from 'axios';
import sha256 from 'crypto-js/sha256';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment'
import { firebaseApp } from './firebase/';
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTimes, faDownload } from '@fortawesome/free-solid-svg-icons'

import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Table from 'react-bootstrap/Table';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Jumbotron from 'react-bootstrap/Jumbotron'
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer, toast } from 'react-toastify'

import {
  SignInButtons,
  saveSignInParam,
  onAuthStateChanged
} from './task/SignInButtons'
import Generator from './admin/Generator'
import TaskEditor from './admin/TaskEditor'
import ImageEditor from './admin/ImageEditor'
import Logs from './admin/Logs'
import Stats from './admin/Stats'
import YouTubeLink from './task/YouTubeLink'
import Footer from './task/Footer'
import PLRButton from './task/PLRButton'
import TempURL from './common/TempURL'

import './AdminApp.css';


const db = firebaseApp.firestore();

const MAX_LOGS = 20

class AdminApp extends Component {
  constructor(props) {
    super(props);

    const url = window.location.href
    this.state = {
      baseURL: url.substring(0, url.indexOf('/dashboard/')),
      user: null,
      loading: true,
      error: null,
      generating: false,
      generated: null,
      context_id: null,
    };
  }

  componentDidMount() {
    onAuthStateChanged(this.auth(), (user, error) => {
      if (error) {
        this.setState({
          error,
        });
        return;
      }
      this.loadTasks(user)
        .then(result => {
            this.setState({
              loading: false,
              generator: (result.tasks || []).filter((task) => !task.data.trash).length === 0 && (result.shared || []).length === 0,
              user,
              tasks: result.tasks,
              logs: result.logs,
              issueLogs: result.issueLogs,
              mylogs: result.mylogs,
              shared: result.shared,
              sharedLogs: result.sharedLogs,
              context_id: result.context_id,
            }, () => {
              const taskId = this.getBaseTaskIdFromParams()
              if (taskId !== null) {
                this.importTask(taskId)
              }
            })
        }).catch((error) => {
          console.error(error)
          this.setState({
            loading: false,
            error: error.message || error,
          })
        })
    })
  }

  componentDidUpdate(prevProps, prevState) {
    this.emitErrorToast(prevState)
    if (this.props.match.params.page === prevProps.match.params.page) {
      return
    }
    if (this.state.user === null) {
      return
    }
    console.log('Page:', this.props.match.params.page)
    this.setState({
      loading: true,
    }, () => {
      this.loadTasks(this.state.user)
        .then(result => {
          this.setState({
            loading: false,
            tasks: result.tasks,
            logs: result.logs,
            issueLogs: result.issueLogs,
            shared: result.shared,
            sharedLogs: result.sharedLogs,
            context_id: result.context_id,
          })
        }).catch((error) => {
          console.error(error)
          this.setState({
            loading: false,
            error: error.message || error,
          })
        })
    })
  }

  emitErrorToast(prevState) {
    if (prevState.error === this.state.error || this.state.error === null) {
      return
    }
    toast.error(`Error: ${this.state.error}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      onClose: () => this.setState({
        error: null
      })
    })
  }

  auth() {
    return this.props.auth || firebase.auth();
  }

  signIn(provider) {
    this.auth().signInWithRedirect(provider)
  }

  signOut() {
    this.auth().signOut()
      .then(() => {
        this.setState({
          user: null,
        });
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
      })
  }

  importTask(taskId) {
    this.performImportTask(this.state.user, taskId)
      .then(imported => {
        window.location.href = `/dashboard/${imported.id}`
      }).catch((error) => {
        console.error(error)
        this.setState({
          loading: false,
          error: error.message || error,
        })
      })
  }

  findTaskData(taskRefs, taskId) {
    const taskCands = taskRefs.docs
      .filter(taskRef => taskRef.data().taskId === taskId)
    if (taskCands.length === 0) {
      return null
    }
    return taskCands[0]
  }

  parseLog(logData) {
    logData.data = JSON.parse(logData.data)
    return logData
  }

  async loadTasks(user) {
    if (user === null) {
      return {
        tasks: [],
        logs: [],
        mylogs: [],
      }
    }
    const userRef = await db.collection('user').doc(user.uid).get()
    const userData = await saveSignInParam(null, userRef)
    userData.code = uuidv4()
    userData.email = user.email
    await db.collection('user').doc(user.uid).set(userData)
    const taskRefs = await db
      .collection('user').doc(user.uid)
      .collection('taskdata').orderBy('updated', 'desc').get()
    const myLogRefs = await db
      .collection('user').doc(user.uid)
      .collection('log')
      .orderBy('finished', 'desc')
      .limit(MAX_LOGS)
      .get()
    const mylogs = myLogRefs.docs.map(logRef => {
      const taskData = this.findTaskData(taskRefs, logRef.data().task)
      return {
        id: logRef.id,
        data: this.parseLog(logRef.data()),
        taskDataId: taskData ? taskData.id : null,
        taskTitle: taskData ? taskData.data().title : null,
      }
    })
    const taskId = this.getTaskIdFromParams()
    const targetTaskRefs = taskRefs.docs
      .filter(taskRef => taskRef.id === taskId)
    let logs = null
    let issueLogs = null
    if (targetTaskRefs.length > 0) {
      const logData = await this.getLogs(
        db
          .collection('user').doc(user.uid)
          .collection('taskdata').doc(targetTaskRefs[0].id)
          .collection('log'),
      )
      logs = logData.logs
      issueLogs = logData.issueLogs
    }
    let context = null
    if (taskId !== null) {
      context = await db
        .collection('context')
        .add({
          started: Date.now(),
          task: taskId,
          uid: user.uid,
        });
    }
    const token = sha256(`USER/${userData.code}/${user.uid}`).toString()
    let sharedLogs = null
    const shared = await this.getShared(user)
    if (taskId !== null) {
      const sharedRefs = shared.filter((ref) => ref.id === taskId)
      if (sharedRefs.length) {
        await this.prepareShared(user, shared, taskId)
        let logsQuery = ''
        if (this.props.match.params.page.split('/')[1] !== 'stats') {
          logsQuery = `?size=${MAX_LOGS}`
        }
        try {
          sharedLogs = await axios.get(`/shared/${user.uid}/${taskId}/logs${logsQuery}`, {
            headers: {'X-CT-Request-Token': token}
          })
        } catch(error) {
          console.warn('Failed to get shared logs', error)
        }
      }
    }
    console.log('Shared', shared)
    return {
      tasks: taskRefs.docs.map(taskRef => ({
        id: taskRef.id,
        data: taskRef.data(),
      })),
      shared: shared || [],
      logs,
      issueLogs,
      sharedLogs: sharedLogs !== null ? sharedLogs.data.logs.map(log => ({
        data: log,
      })) : null,
      mylogs,
      context_id: context === null ? null : context.id,
    }
  }

  async getLogs(baseLogQuery) {
    let logQuery = baseLogQuery
      .orderBy('finished', 'desc')
    if (this.props.match.params.page.split('/')[1] !== 'stats') {
      logQuery = logQuery.limit(MAX_LOGS)
    }
    const logRefs = await logQuery.get()
    const logs = logRefs.docs.map(logRef => ({
        id: logRef.id,
        data: this.parseLog(logRef.data()),
      }))
    const issueLogRefs = await baseLogQuery
      .where('type', '==', 'report.issue')
      .get()
    const issueLogs = issueLogRefs.docs.map(logRef => ({
        id: logRef.id,
        data: logRef.data(),
      }))
    issueLogs.sort((e1, e2) => (e1.data.finished < e2.data.finished ? -1 : (e1.data.finished > e2.data.finished) ? 1 : 0))
    return { logs, issueLogs }
  }

  async generate(title, description, text, baseTaskDataId, requireAuth, mode, choiceCounts) {
    const taskContent = {
      title,
      description,
      text,
      require_auth: requireAuth,
      choice_counts: choiceCounts,
      generating: true,
      mode: mode || 'normal',
    }
    if (baseTaskDataId) {
      taskContent.base = baseTaskDataId
    }
    const taskData = await db
      .collection('user')
      .doc(this.state.user.uid)
      .collection('taskdata')
      .add(taskContent)
    const result = await axios.post('/tasks', {
      uid: this.state.user.uid,
      task_data_id: taskData.id,
    });
    return result;
  }

  requestGenerate(title, description, text, baseTaskDataId, requireAuth, mode, choiceCounts) {
    console.log('Generate cloze Test', title, description)
    this.setState({
      generating: true,
    }, () => {
      this.generate(title, description, text, baseTaskDataId, requireAuth, mode, choiceCounts)
        .then((resp) => {
          console.log('Generated', resp)
          this.setState({
            generating: false,
            generated: resp.data.task_data_id,
          })
        }).catch((error) => {
          console.error(error)
          this.setState({
            generating: false,
            error: error.message || error,
          })
        })
    })
  }

  closeGenerated() {
    this.setState({
      generated: null,
    });
  }

  getSharedID(taskRef) {
    const { user_id, taskdata_id } = this.getSharedDesc(taskRef)
    return `${user_id.substring(0, 8)}-${taskdata_id}`
  }

  getSharedDesc(taskRef) {
    const m = taskRef.ref.path.match(/^user\/(.+)\/taskdata\/(.+)$/)
    return {
      user_id: m[1],
      taskdata_id: m[2],
    }
  }

  async getShared(user) {
    const sharedRefs = await db.collectionGroup('taskdata')
      .where('shares', 'array-contains', user.email)
      .get()
    return sharedRefs.docs.map(taskRef => ({
      id: this.getSharedID(taskRef),
      data: Object.assign({
        shared: this.getSharedDesc(taskRef),
      }, taskRef.data()),
    }))
  }

  async updateTasksForAll(endpoint, options) {
    const result = await axios.post(endpoint, options)
    console.log('Performed', result)
    if (!result.data.has_remains) {
      return result
    }
    return await this.updateTasksForAll(endpoint, options)
  }

  async updateTask(taskId, taskData, updateEndpoint, updateAction) {
    taskData.edited = Date.now()
    taskData.updated = taskData.edited
    taskData.remainSentencesIndex = null
    taskData.processedData = null
    taskData.processedChunksData = null
    taskData.processedWordsData = null
    await db
      .collection('user')
      .doc(this.state.user.uid)
      .collection('taskdata')
      .doc(taskId)
      .set(taskData)
    if (updateEndpoint) {
      const result = await this.updateTasksForAll(updateEndpoint, {
        uid: this.state.user.uid,
        task_data_id: taskId,
      })
      console.log('Sentences updated', result)
    } else {
      const result = await this.updateTasksForAll('/tasks', {
        uid: this.state.user.uid,
        task_data_id: taskId,
        action: updateAction,
      })
      console.log('Properties Updated', result, updateAction)
    }
    const taskRefs = await db
      .collection('user').doc(this.state.user.uid)
      .collection('taskdata').orderBy('updated', 'desc').get()
    return {
      tasks: taskRefs.docs.map(taskRef => ({
        id: taskRef.id,
        data: taskRef.data(),
      })),
    }
  }

  saveTaskChanges(changes, callback) {
    const taskId = this.getTaskIdFromParams()
    const task = this.state.tasks.filter(task => task.id === taskId)[0]
    console.log('CHANGES', taskId, task, changes)
    const taskData = Object.assign({}, task.data)
    Object.entries(changes).forEach(change => {
      if (change[1] === undefined) {
        return
      }
      taskData[change[0]] = change[1]
    })
    this.updateTask(taskId, taskData, null, 'properties')
      .then((result) => {
        this.setState({
          tasks: result.tasks,
        }, () => {
          if (!callback) {
            return
          }
          callback()
        })
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
      })
  }

  deleteTask(callback) {
    const taskId = this.getTaskIdFromParams()
    const task = this.state.tasks.filter(task => task.id === taskId)[0]
    console.log('DELETE', taskId, task)
    const taskData = Object.assign({}, task.data)
    taskData.trashed = Date.now()
    taskData.trash = true
    this.updateTask(taskId, taskData, null, 'properties')
      .then((result) => {
        this.setState({
          tasks: result.tasks,
        }, () => {
          if (!callback) {
            return
          }
          callback()
        })
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
      })
  }

  restoreTask(callback) {
    const taskId = this.getTaskIdFromParams()
    const task = this.state.tasks.filter(task => task.id === taskId)[0]
    console.log('DELETE', taskId, task)
    const taskData = Object.assign({}, task.data)
    taskData.trashed = null
    taskData.trash = false
    this.updateTask(taskId, taskData, null, 'properties')
      .then((result) => {
        this.setState({
          tasks: result.tasks,
        }, () => {
          if (!callback) {
            return
          }
          callback()
        })
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
      })
  }

  saveSharesChanges(shares, callback) {
    const taskId = this.getTaskIdFromParams()
    const task = this.state.tasks.filter(task => task.id === taskId)[0]
    console.log('CHANGES', taskId, shares)
    const taskData = Object.assign({}, task.data)
    taskData.shares = shares
    taskData.user_email = this.state.user.email
    this.updateTask(taskId, taskData, null, 'properties')
      .then((result) => {
        this.setState({
          tasks: result.tasks,
        }, () => {
          if (!callback) {
            return
          }
          callback()
        })
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
      })
  }

  saveSentencesChanges(changes, callback) {
    const taskId = this.getTaskIdFromParams()
    const task = this.state.tasks.filter(task => task.id === taskId)[0]
    console.log('SENTENCES CHANGES', taskId, task, changes)
    const taskData = Object.assign({}, task.data)
    taskData.sentences = JSON.stringify(changes)
    taskData.generating = true
    this.updateTask(taskId, taskData)
      .then((result) => {
        this.setState({
          tasks: result.tasks,
        }, () => {
          if (!callback) {
            return
          }
          callback()
        })
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
        if (!callback) {
          return
        }
        callback()
      })
  }

  async performResolveIssue(logId, resolved) {
    const logData = Object.assign({}, (this.state.issueLogs || []).filter(log => log.id === logId)[0].data)
    logData.resolved = resolved
    await db
      .collection('user').doc(this.state.user.uid)
      .collection('taskdata').doc(this.getTaskIdFromParams())
      .collection('log').doc(logId)
      .set(logData)
  }

  resolveIssue(logId, resolved) {
    this.performResolveIssue(logId, resolved)
      .then((result) => {
        const issueLogs = (this.state.issueLogs || [])
          .map(log => ({
            id: log.id,
            data: log.id === logId ? Object.assign(Object.assign({}, log.data), {
              resolved,
            }) : log.data
          }))
        this.setState({
          issueLogs,
        })
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
      })
  }

  resolveWordIssues(logIds, resolved) {
    const tasks = logIds.map(logId => this.performResolveIssue(logId, resolved))
    Promise.all(tasks)
      .then((result) => {
        const issueLogs = (this.state.issueLogs || [])
          .map(log => ({
            id: log.id,
            data: logIds.includes(log.id) ? Object.assign(Object.assign({}, log.data), {
              resolved,
            }) : log.data
          }))
        this.setState({
          issueLogs,
        })
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
      })
  }

  async performGenerateRow(taskData, text, force) {
    const options = {
      text,
      mode: taskData.mode,
      choice_counts: taskData.choice_counts,
      force,
    }
    return await axios.post(`/generator/${this.state.context_id}/rows`, options)
  }

  generateRow(taskData, text, force, callback) {
    this.performGenerateRow(taskData, text, force)
      .then((result) => {
        if (!callback) {
          return
        }
        callback(result.data.row, result.data.chunksRow, result.data.words)
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
        if (!callback) {
          return
        }
        callback()
      })
  }

  async performImportTask(user, taskId) {
    const userRef = await db.collection('user').doc(user.uid).get()
    const userData = userRef.exists ? userRef.data() : {}
    const token = sha256(`USER/${userData.code}/${user.uid}`).toString()

    const taskData = await axios.get(`/taskdata/${user.uid}/${taskId}`, {
      headers: {'X-CT-Request-Token': token}
    })
    console.log('TaskData', taskData)

    return await this.performCopyShared({
      user_id: taskData.data.user_id,
      taskdata_id: taskData.data.taskdata_id,
    }, taskData.data)
  }

  async performCopyShared(baseId, shared) {
    const sharedData = Object.assign({}, shared.data)
    sharedData.taskId = null
    sharedData.edited = Date.now()
    sharedData.updated = sharedData.edited
    sharedData.logupdated = null
    sharedData.logs = 0
    sharedData.links = '{}'
    sharedData.importable = false
    if (sharedData.require_auth) {
      sharedData.base_require_auth = sharedData.require_auth
    }
    if (sharedData.whitelist_auth) {
      sharedData.base_whitelist_auth = sharedData.whitelist_auth
    }
    sharedData.shares = []
    if (!sharedData.base) {
      sharedData.base = `${baseId.user_id} ${baseId.taskdata_id}`
    }
    console.log('Add taskdata', sharedData)
    const added = await db
      .collection('user')
      .doc(this.state.user.uid)
      .collection('taskdata')
      .add(sharedData)
    const result = await axios.post('/tasks', {
      uid: this.state.user.uid,
      task_data_id: added.id,
      action: 'properties',
    })
    console.log('Properties Updated', result)
    return added
  }

  copyShared() {
    const taskId = this.getTaskIdFromParams()
    db
      .collection('user').doc(this.state.user.uid)
      .collection('shared').doc(taskId).get()
      .then((sharedRef) => {
        const shared = this.state.shared.filter(task => task.id === taskId)[0]
        this.performCopyShared(sharedRef.data(), shared)
          .then((added) => {
            window.location.href = `/dashboard/${added.id}`
          }).catch((error) => {
            console.error(error)
            this.setState({
              error: error.message || error,
            })
          })
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
      })
  }

  async createAllLogContext() {
    const started = Date.now()
    const contextData = {
      started,
      uid: this.state.user.uid,
      all: true,
    }
    const added = await db
      .collection('context')
      .add(contextData)
    await db
      .collection('user')
      .doc(this.state.user.uid)
      .collection('context')
      .doc(added.id)
      .set(contextData)
    return {
      id: added.id,
      expiration: started + 1000 * 60 * 5,
    }
  }

  async prepareShared(user, shared, taskId, logContext) {
    const sharedDesc = (shared || []).filter(task => task.id === taskId)[0]
    const sharedDoc = db
      .collection('user')
      .doc(user.uid)
      .collection('shared')
      .doc(taskId)
    await sharedDoc.set(Object.assign({
      logContext: logContext || null,
      updated: Date.now(),
    }, sharedDesc.data.shared))
  }

  async createSharedLogContext(taskId) {
    const started = Date.now()
    const added = await db
      .collection('context')
      .add({
        started,
        task: taskId,
        uid: this.state.user.uid,
        shared: true,
      })
    await this.prepareShared(this.state.user, this.state.shared, taskId, added.id)
    return {
      id: added.id,
      expiration: started + 1000 * 60 * 5,
    }
  }

  async createLogContext(taskId) {
    const started = Date.now()
    const added = await db
      .collection('context')
      .add({
        started,
        task: taskId,
        uid: this.state.user.uid,
      })
    const task = this.state.tasks.filter(task => task.id === taskId)[0]
    const taskData = Object.assign({}, task.data)
    taskData.logContext = added.id
    await db
      .collection('user')
      .doc(this.state.user.uid)
      .collection('taskdata')
      .doc(taskId)
      .set(taskData)
    return {
      id: added.id,
      expiration: started + 1000 * 60 * 5,
    }
  }

  createSharedLogURL(callback) {
    const taskId = this.getTaskIdFromParams()
    this.createSharedLogContext(taskId)
      .then((context) => {
        if (!callback) {
          return
        }
        callback(`/logs/${context.id}`, context.expiration)
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
      })
  }

  createLogURL(callback) {
    const taskId = this.getTaskIdFromParams()
    this.createLogContext(taskId)
      .then((context) => {
        if (!callback) {
          return
        }
        callback(`/logs/${context.id}`, context.expiration)
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
      })
  }

  downloadStats(createLogContext) {
    const taskId = this.getTaskIdFromParams()
    createLogContext(taskId)
      .then((context) => {
        window.open(`/stats/${context.id}`, '_blank')
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
      })
  }

  createAPIURL(callback) {
    const taskId = this.getTaskIdFromParams()
    this.createAllLogContext(taskId)
      .then((context) => {
        if (!callback) {
          return
        }
        callback(`/api/v1/contexts/${context.id}/`, context.expiration)
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
      })
  }

  getTaskIdFromParams() {
    if (!this.props.match.params.page) {
      return null
    }
    if (this.props.match.params.page === 'new') {
      return null
    }
    if (this.props.match.params.page === 'trash') {
      return null
    }
    return this.props.match.params.page.split('/')[0]
  }

  getBaseTaskIdFromParams() {
    if (!this.props.match.params.page) {
      return null
    }
    if (!this.props.match.params.page.startsWith('import/')) {
      return null
    }
    return this.props.match.params.page.split('/')[1]
  }

  renderGenerateButton() {
    return <Link to='/dashboard/new'>
      <Button
        data-test-new-cloze-test
        variant='success'>
        <FontAwesomeIcon icon={faPlus} />
        Cloze Testを新規作成
      </Button>
    </Link>
  }

  renderGenerator() {
    return this.state.generated ?
      <Alert variant="success">
        <p>Cloze Testを生成しました！ <a href={`/dashboard/${this.state.generated}`}>詳細</a>を確認してください</p>
      </Alert> :
      ((this.state.generator || this.props.match.params.page === 'new') ?
        <div className='NewCloze'>
          {!this.state.generator && <Link to='/dashboard/'>
            <Button
              data-test-cloze-list
              variant='light'>
              <FontAwesomeIcon icon={faTimes} />
              新規作成フォームを閉じる
            </Button>
          </Link>}
          <Generator
            generating={this.state.generating}
            onRequest={(title, description, text, baseTaskDataId, requireAuth, mode, choiceCounts) =>
              this.requestGenerate(title, description, text, baseTaskDataId, requireAuth, mode, choiceCounts)} />
        </div> :
        (this.getTaskIdFromParams() === null && (this.state.tasks || []).filter((task) => !task.data.trash).length === 0 && <div className='NewCloze'>
          {this.renderGenerateButton()}
        </div>))
  }

  renderTaskEditor() {
    const returnToEditor = <div><Link to={`/dashboard/${this.getTaskIdFromParams()}`}>
        <Button
          data-test-cloze-list
          variant='light'>
          Cloze Test編集ページに戻る
        </Button>
      </Link></div>

    const imageEditor = (this.state.tasks || []).filter(task => task.id === this.getTaskIdFromParams()).length > 0 &&
      <div>
        {returnToEditor}
        <ImageEditor
          taskid={this.getTaskIdFromParams()}
          context={this.state.context_id}
          taskdata={this.state.tasks.filter(task => task.id === this.getTaskIdFromParams())[0]}
          onSaveChanges={(changes, callback) => this.saveSentencesChanges(
            changes, callback
          )}
        />
      </div>
    const stats = (this.state.tasks || []).filter(task => task.id === this.getTaskIdFromParams()).length > 0 &&
      <div>
        {returnToEditor}
        <Stats
          taskdata={this.state.tasks.filter(task => task.id === this.getTaskIdFromParams())[0]}
          logs={this.state.logs}
        />
      </div>
    const sharedStats = (this.state.shared || []).filter(task => task.id === this.getTaskIdFromParams()).length > 0 &&
      <div>
        {returnToEditor}
        <Stats
          taskdata={this.state.shared.filter(task => task.id === this.getTaskIdFromParams())[0]}
          logs={this.state.sharedLogs}
        />
      </div>
    return <div>
      {!this.props.match.params.page.split('/')[1] &&
        <Link to='/dashboard/'>
          <Button
            data-test-cloze-list
            variant='light'>
            一覧に戻る
          </Button>
        </Link>}
        {this.state.tasks.filter(task => task.id === this.getTaskIdFromParams()).length > 0 &&
          this.props.match.params.page.split('/')[1] === 'image' &&
          imageEditor}
        {this.state.tasks.filter(task => task.id === this.getTaskIdFromParams()).length > 0 &&
          this.props.match.params.page.split('/')[1] === 'stats' &&
          stats}
        {this.state.tasks.filter(task => task.id === this.getTaskIdFromParams()).length > 0 &&
          !this.props.match.params.page.split('/')[1] &&
          <TaskEditor
            taskid={this.getTaskIdFromParams()}
            uid={this.state.user.uid}
            userEmail={this.state.user.email}
            readonly={this.state.tasks.filter(task => task.id === this.getTaskIdFromParams())[0].data.trash}
            taskdata={this.state.tasks.filter(task => task.id === this.getTaskIdFromParams())[0]}
            logs={this.state.logs}
            issueLogs={this.state.issueLogs}
            tasks={this.state.tasks.filter((task) => !task.data.trash)}
            maxlogs={MAX_LOGS}
            onSaveChanges={(changes, callback) => this.saveTaskChanges(
              changes, callback
            )}
            onDelete={(callback) => this.deleteTask(callback)}
            onRestore={(callback) => this.restoreTask(callback)}
            onCreateLogURL={(callback) => this.createLogURL(
              callback
            )}
            onDownloadStats={() => this.downloadStats(
              (taskId) => this.createLogContext(taskId)
            )}
            onSharesChanges={(shares, callback) => this.saveSharesChanges(
              shares,
              callback
            )}
            onGenerateRow={(taskData, text, force, callback) => this.generateRow(
              taskData,
              text,
              force,
              callback
            )}
            onResolve={(logId, resolved) => this.resolveIssue(logId, resolved)}
            onWordResolve={(logIds, resolved) => this.resolveWordIssues(logIds, resolved)}
          />}
        {this.state.shared.filter(task => task.id === this.getTaskIdFromParams()).length > 0 &&
          this.props.match.params.page.split('/')[1] === 'stats' &&
          sharedStats}
        {this.state.shared.filter(task => task.id === this.getTaskIdFromParams()).length > 0 &&
          <div>
            <Button
              data-test-cloze-import
              onClick={ev => this.copyShared()}
              variant='light'>
              <FontAwesomeIcon icon={faPlus} />
              Cloze Testを自身のアカウントにコピー
            </Button>
            <TaskEditor
              taskid={this.getTaskIdFromParams()}
              uid={this.state.user.uid}
              taskdata={this.state.shared.filter(task => task.id === this.getTaskIdFromParams())[0]}
              logs={this.state.sharedLogs}
              maxlogs={MAX_LOGS}
              readonly={true}
              onCreateLogURL={(callback) => this.createSharedLogURL(
                callback
              )}
              onDownloadStats={() => this.downloadStats(
                (taskId) => this.createSharedLogContext(taskId)
              )}
            />
          </div>}
        {this.state.tasks.filter(task => task.id === this.getTaskIdFromParams()).length === 0 &&
          this.state.shared.filter(task => task.id === this.getTaskIdFromParams()).length === 0 &&
          <div className='Error'>
            タスクが見つかりません: {this.props.match.params.page}
          </div>}
      </div>
  }

  renderTasks(tasks, additionalTitle, additionalMessage, emptyMessage) {
    return <div>
      <h2>Cloze Test 問題一覧{additionalTitle}</h2>
      {tasks.length === 0 ?
        <div>
          {emptyMessage || '該当する Cloze Test 問題はありません。'}
          {additionalMessage}
        </div> :
        <div>
          <p>
            #問題IDをクリックすると、問題の詳細を確認・編集することができます。
            {additionalMessage}
          </p>
          {this.props.match.params.page !== 'trash' && <div className='TaskListButtons'>
              {this.renderGenerateButton()}
              <Button
                data-test-all-stats
                onClick={() => this.downloadStats(
                  (taskId) => this.createAllLogContext()
                )}
                variant='light'>
                <FontAwesomeIcon icon={faDownload} />
                実施状況CSVをダウンロード
              </Button>
              <TempURL
                baseURL={this.state.baseURL}
                onCreateURL={(callback) => this.createAPIURL(callback)}
                name='APIアクセスURL'
                notice='(1時間限定)'
              />
            </div>}
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#問題ID</th>
                <th>タイトル</th>
                <th>本文</th>
                <th>更新日</th>
                <th>ログ追加日</th>
                <th>ログ登録数</th>
              </tr>
            </thead>
            <tbody>
              {tasks.map(task => <tr key={task.id}>
                  <td><Link to={`/dashboard/${task.id}`}>{task.id}</Link></td>
                  <td>{task.data.title}</td>
                  <td>{(task.data.text || '').split(' ').slice(0, 5).join(' ') + '...'}</td>
                  <td>{moment(new Date(task.data.updated)).format()}</td>
                  <td>{task.data.logupdated ? moment(new Date(task.data.logupdated)).format() : '-'}</td>
                  <td>{task.data.logs ? `${task.data.logs}` : '-'}</td>
                </tr>)}
            </tbody>
          </Table>
        </div>}
    </div>
  }

  renderTrash() {
    return <div>
        <div className='ReturnDashboard'>
          <Link to='/dashboard/'>&lt;&lt;ダッシュボードに戻る</Link>
        </div>
        {this.renderTasks((this.state.tasks || []).filter(task => task.data.trash), ' - ゴミ箱')}
      </div>
  }

  renderUserLogs() {
    return <div>
        {this.renderTasks((this.state.tasks || []).filter(task => !task.data.trash),
          undefined,
          <span>
            自分の持っている文章から<Link to='/dashboard/new'>新規作成</Link>をすることができます。
          </span>,
          'Cloze Test 問題はまだ登録されていません。')}
        <div className='TrashList'><Link to='/dashboard/trash'>&gt;&gt;ゴミ箱</Link></div>
        <h2>共有されているCloze Test 問題一覧</h2>
        {(this.state.shared || []).length === 0 ?
          <div>
            共有されているCloze Test 問題はありません。
          </div> :
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#問題ID</th>
                <th>共有者</th>
                <th>タイトル</th>
                <th>説明</th>
                <th>更新日</th>
                <th>ログ追加日</th>
                <th>ログ登録数</th>
              </tr>
            </thead>
            <tbody>
              {(this.state.shared || []).map(task => <tr key={task.id}>
                  <td><Link to={`/dashboard/${task.id}`}>{task.id}</Link></td>
                  <td>{task.data.user_email}</td>
                  <td>{task.data.title}</td>
                  <td>{(task.data.text || '').split(' ').slice(0, 5).join(' ') + '...'}</td>
                  <td>{moment(new Date(task.data.updated)).format()}</td>
                  <td>{task.data.logupdated ? moment(new Date(task.data.logupdated)).format() : '-'}</td>
                  <td>{task.data.logs ? `${task.data.logs}` : '-'}</td>
                </tr>)}
            </tbody>
          </Table>}
        <h2>Cloze Test実施ログ</h2>
        <div className='PLR'>
          <PLRButton
            db={db}
            uid={this.state.user && this.state.user.uid}
            onError={e => this.setState({
              error: e.message || e,
            })}
          />
        </div>
        <Logs personal={true} logs={this.state.mylogs} maxlogs={MAX_LOGS} />
      </div>
  }

  renderIntroduction() {
    return <div>
      <p>Cloze Testは、一部が空欄になった文章を穴埋めすることで解くスタイルの英語問題です。</p>
      <p>
        <YouTubeLink title="使い方動画(YouTube)" youtubeid="-N8Hl9v9gGw" />
      </p>
    </div>
  }

  render() {
    return <div>
      <Navbar collapseOnSelect expand='lg' bg='navbar-default' sticky='top' variant='dark'>
        <Navbar.Brand href="/dashboard/">
          <img
            alt=""
            src="/logo192.png"
            width="30"
            height="30"
            className="d-inline-block align-top"
          />{' '}
          Dashboard - Cloze Test
          {this.state.user !== null &&
            <span id='mitou_ml_account'>{this.state.user.email}</span>}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls='responsive-navbar-top' />
        <Navbar.Collapse id='responsive-navbar-top' className='justify-content-end'>
          <Nav>
            <NavDropdown title='使い方'>
              <NavDropdown.Item href='https://youtu.be/-N8Hl9v9gGw' target='_blank'>
                使い方動画(YouTube)
              </NavDropdown.Item>
            </NavDropdown>
            {this.state.user === null ?
              <Navbar.Text>
                ログインしていません
              </Navbar.Text> :
              <NavDropdown
                title={`ログイン中: ${this.state.user.email}`}>
                <NavDropdown.Item href='/recent/'>
                  最近参照した問題
                </NavDropdown.Item>
                <NavDropdown.Item href='/notice/' target='_blank'>
                  利用上の注意(対応ブラウザ)
                </NavDropdown.Item>
                <NavDropdown.Item href='/inquiry/' target='_blank'>
                  お問い合わせ
                </NavDropdown.Item>
                <NavDropdown.Item onClick={e => this.signOut()}>
                  ログアウト
                </NavDropdown.Item>
              </NavDropdown>}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <div className='AdminApp'>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          />
        {this.state.loading ? <div className='Loading'>
          <ClipLoader />
          <div>Loading...</div>
        </div> : (this.state.user === null ? <div className='Login'>
          <Jumbotron>
            <h1>Cloze Testダッシュボード</h1>
            <SignInButtons
              description='Cloze Testアプリのダッシュボードを使用するためには、'
              signIn={(provider) => this.signIn(provider)}
            />
          </Jumbotron>
          <h2>Cloze Testアプリ</h2>
          {this.renderIntroduction()}
          <Footer />
        </div> : <div>
          {this.getTaskIdFromParams() === null && this.getBaseTaskIdFromParams() === null &&
            this.props.match.params.page !== 'trash' &&
            this.renderGenerator()}
          {this.getTaskIdFromParams() !== null && this.getBaseTaskIdFromParams() === null &&
            this.renderTaskEditor()}
          {this.getBaseTaskIdFromParams() !== null &&
            <div>
              <ClipLoader />
              <div>問題をアカウントにコピーしています...</div>
            </div>}
          {this.props.match.params.page === 'trash' &&
            this.renderTrash()}
          {!this.props.match.params.page &&
            this.renderUserLogs()}
        </div>)}
      </div>
    </div>
  }
}

export default AdminApp;
